var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentJewelSelection &&
    _vm.currentJewelSelection.suggestedJewels &&
    _vm.currentJewelSelection.suggestedJewels.length > 0
    ? _c(
        "div",
        {
          staticClass: "position-relative",
          class: "total-wrapper-" + _vm.theme
        },
        [
          _c(
            "span",
            {
              class: {
                "text-uppercase title-related ml-md-3": _vm.theme === 1,
                "text-uppercase title-related-2 mt-3": _vm.theme === 2,
                "ama-title-related": _vm.isAma
              }
            },
            [_vm._v(_vm._s(_vm.$t("relatedJewels")))]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "swiper",
                  rawName: "v-swiper:mySwiper",
                  value: _vm.swiperOptions,
                  expression: "swiperOptions",
                  arg: "mySwiper"
                }
              ]
            },
            [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(_vm.currentJewelSelection.suggestedJewels, function(
                  item
                ) {
                  return _c(
                    "div",
                    {
                      key: item.sku,
                      staticClass: "swiper-slide cursor-pointer",
                      on: {
                        click: function($event) {
                          return _vm.selectJewel(item)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "w-100 p-2" }, [
                        _c("div", { class: "parent-img-" + _vm.theme }, [
                          _c("img", {
                            class: [
                              "border-img-" + _vm.theme,
                              item.category === 3 || item.category === 20
                                ? "pendant-image"
                                : ""
                            ],
                            attrs: { src: _vm.baseImageUrl + item.image }
                          }),
                          _vm.position &&
                          item &&
                          item.minPrice &&
                          item.descriptions
                            ? _c("span", { staticClass: "jewel-name" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.descriptions[_vm.position].name
                                    ) +
                                    " "
                                ),
                                _c("br"),
                                _vm._v(
                                  " €" +
                                    _vm._s(
                                      parseFloat(
                                        item.minPrice * _vm.vat * _vm.retailPerc
                                      )
                                        .toFixed(2)
                                        .toLocaleString("it-it")
                                    ) +
                                    " "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]
                  )
                }),
                0
              ),
              _c("div", {
                staticClass: "swiper-button-prev",
                attrs: { slot: "button-prev" },
                slot: "button-prev"
              }),
              _c("div", {
                staticClass: "swiper-button-next",
                attrs: { slot: "button-next" },
                slot: "button-next"
              })
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }